/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { buildLocalizedUrl } from "./url.utils";

import type { LocalizedUrlOptions } from "./url.utils";

export interface AlternatesProps {
	canonical: string;
	languages: { [key: string]: string };
}

export const getAlternates = (
	locale: string,
	slug: string,
	locales?: string[],
	defaultLocale?: string,
	urlOptions?: LocalizedUrlOptions,
): AlternatesProps => {
	const { fullUrl } = buildLocalizedUrl(locale, slug, defaultLocale, urlOptions);
	const languages: { [key: string]: string } = {};
	if (locales?.length) {
		const effectiveDefault = defaultLocale || locale;
		for (const loc of locales) {
			if (loc === effectiveDefault) continue;
			languages[loc] = buildLocalizedUrl(loc, slug, effectiveDefault, urlOptions).fullUrl;
		}
		const { plainUrl } = buildLocalizedUrl(effectiveDefault, slug, effectiveDefault, urlOptions);
		languages[effectiveDefault] = plainUrl;
		languages["x-default"] = plainUrl;
	}
	return { canonical: fullUrl, languages };
};
